import { FC } from "react"
import React, { useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import { useSearchParams, useLocation, useHistory } from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';

//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const DeleteSchool: FC = () => {
  const intl = useIntl()
  let history = useHistory();

  const [schoolInfo, setschoolInfo] = useState([]);

  const location99 = useLocation();
  const queryParams99 = new URLSearchParams(location99.search);
  const schoolId = queryParams99.get('schoolId');
  const [schoolProfileInfo, setSchoolProfile] = useState([]);
  const red = "red";
  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function handleChangeSchoolProfileDesc(content) {
    setSchoolProfile(content);
  }

  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }
  function adminViewSchool() {
    const requestObject = {
      "schoolId": schoolId
    };
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminViewSchool(requestOptions).then((res) => {
      const myres = JSON.stringify(res);
      console.log(res.name);
      if (res) {
        $('#school_name').val(res.name);
        $('#address_line1').val(res.address);
        $('#address_line2').val(res.address1);
        $('#school_city').val(res.city);
        $('#school_state').val(res.state);
        $('#postalcode').val(res.zip);
        $('#phone_number').val(res.phone);
        $('#email_id').val(res.email);
        $('#school_type').val(res.schoolTypeId);
        // console.log(res.data);         
        setschoolInfo(res);
      }
    });


  }
  const submitValue = () => {

    const requestObject = {
      "schoolId": schoolId,
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminDeleteSchool(requestOptions).then((res) => {
      if (res.code == '200') {
        $("#deleteschoolsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#deleteschoolsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/schoollist');
        }, 1000);
      }
      else {
        $("#deleteschoolfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#deleteschoolfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);

      }
    });

  }
  useEffect(() => {
    adminViewSchool();
    $("#schoolProfileValidMsg").hide();
    $(".se-dialog-tabs").hide();
    $("#deleteschoolsuccessMessage").hide();
    $("#deleteschoolfailMessage").hide();

  }, []);
  type Props = {
    className: string
  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'Delete School' })}</PageTitle>

      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">School Name </label>

                </div>
                <input id="school_name" name="school_name" type="text" className="form-control" readOnly placeholder="" />

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Address </label>

                </div>
                <input type="text" id="address_line1" name="address_line1" className="form-control" readOnly placeholder="" />

              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Address 2</label>

                </div>
                <input type="text" readOnly id="address_line2" name="address_line2" className="form-control" placeholder="" />

              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">City</label>

                </div>
                <input type="text" id="school_city" readOnly name="school_city" className="form-control" placeholder="" />

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">State</label>

                </div>
                <input type="text" id="school_state" name="school_state" readOnly className="form-control" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">Zipcode</label>

                </div>
                <input type="text" readOnly id="postalcode" name="postalcode" className="form-control" placeholder="" />

              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">School Type</label>

                </div>
                <select className="form-select" id="school_type" name="school_type" aria-label="Select example" >
                  <option selected value=''>Select School Type</option>
                  <option value="1">College/University</option>
                  <option value="2">Higher Education</option>
                  <option value="3">School District</option>
                  <option value="3">Trade School</option>
                  <option value="3">Vocational</option>
                </select>

              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Phone</label>
                  <small className="mb-3">xxx-xxx-xxxx</small>
                </div>
                <input type="text" readOnly id="phone_number" name="phone_number" className="form-control" placeholder="" />

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Email</label>
                  <small className="mb-3">Must be valid for notification</small>
                </div>
                <input type="text" readOnly id="email_id" name="email_id" className="form-control" placeholder="" />

              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" class="required form-label">School Profile</label>
                  <small className="mb-3">Max 5000 Characters</small>
                </div>
                {/*}<h1>this is FCK editor area</h1>*/}
                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSchoolProfileDesc}
                  setContents={schoolInfo.content}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                {/* <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="schoolProfileId"    
                            data = {schoolInfo.content}    
                            readOnly                
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setSchoolProfile(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        /> */}
                <div id="schoolProfileValidMsg" style={{ color: red }} className="error">This field is required.</div>

              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">School Logo</label>
                  <small className="mb-3">JPG or PNG, 500px X 500px, .5 MB max size</small>
                </div>
                <img src={schoolInfo.logoUrl} alt />
              </div>
            </div>

            <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "135px" }}> Delete School </button>

          </div>

          <div id="deleteschoolsuccessMessage" class="alert alert-success" role="alert">School Deleted Successfully</div>
          <div id="deleteschoolfailMessage" class="alert alert-danger" role="alert">Please try again</div>

        </div>
      </form>
    </>
  )
}
export { DeleteSchool }